import i18n from "i18next";

import { initReactI18next } from "react-i18next";

const params = new URLSearchParams(document.location.search);
const urlLanguage = params.get("language");
const savedLanguage = localStorage.getItem("cpq.languageCode");
const appLanguage = urlLanguage || savedLanguage || "en-US";

i18n.use(initReactI18next).init({
  lng: appLanguage,
  fallbackLng: "en-US",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
